import { bankApi, USE_XSRF_HEADER } from '@/api'
import {
  IAccountCountResponse,
  IAccountTransaction,
  ISimpleAccountList,
  MAX_ACCOUNT_COUNT,
} from '@/domains/AccountDomain'

const BASE = '/accounts'

export function fetchSimpleAccountList(): Promise<ISimpleAccountList> {
  return bankApi.post(`${BASE}/list`, {
    page: 1,
    rowCnt: MAX_ACCOUNT_COUNT,
  })
}

export interface INoteAddRequest {
  hisNo: string // 거래 이력 번호
  refNo: string // 거래 참조 번호
  trxNote: string // 거래 노트
}

export const addNote = (data: INoteAddRequest): Promise<string> => {
  return bankApi.post(`${BASE}/note`, data, USE_XSRF_HEADER)
}

export const fetchAccountCount = (): Promise<IAccountCountResponse> => {
  return bankApi.post(`${BASE}/check-count`)
}

export interface IAccountRequest {
  acctNo: string
}

export interface IAccountResponse {
  acctCcy: string
  acctColor: number
  acctNo: string
  acctPrdNm: string
  acctTitle: string
  bsJan: string
  cbsObbAmt: string
  contStsNm: string
  curJan: string
  custNm: string
  debitCardNo: string
  detail: { description: string }
  dpAcctYn: string
  dptBasicRt: string
  isDebitCardIssued: boolean
  openDtm: number
  sbjNm: string
  stopAmt: string
  subjCd: string
}

export const fetchAccountBasicInfo = (data: IAccountRequest): Promise<IAccountResponse> => {
  return bankApi.post(`${BASE}/basic`, data)
}

export interface IAccountTransactionInfo {
  hisNo: string // 거래 이력 번호
  refNo: string // 거래 참조 번호
}

export interface IAccountTransactionInfoResponse extends IAccountTransaction {}

export const fetchAccountTransactionInfo = (
  data: IAccountTransactionInfo,
): Promise<IAccountTransactionInfoResponse> => {
  return bankApi.post(`${BASE}/transaction-info`, data)
}
